import { render, staticRenderFns } from "./bdd.vue?vue&type=template&id=6ae9d70d&"
import script from "./bdd.vue?vue&type=script&lang=ts&"
export * from "./bdd.vue?vue&type=script&lang=ts&"
import style0 from "./bdd.vue?vue&type=style&index=0&id=6ae9d70d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports